import React, { useRef, useEffect, useCallback } from 'react';

/**
 * Wrapper for wide tables that shows a horizontal scrollbar at both top and bottom.
 */
export function DualScrollTable({ children, className = '' }) {
    const topScrollRef = useRef(null);
    const bottomScrollRef = useRef(null);
    const contentRef = useRef(null);
    const syncing = useRef(false);

    const syncWidth = useCallback(() => {
        if (contentRef.current && topScrollRef.current) {
            const inner = topScrollRef.current.querySelector('.scroll-spacer');
            if (inner) {
                inner.style.width = contentRef.current.scrollWidth + 'px';
            }
        }
    }, []);

    useEffect(() => {
        syncWidth();
        const observer = new ResizeObserver(syncWidth);
        if (contentRef.current) observer.observe(contentRef.current);
        return () => observer.disconnect();
    }, [syncWidth, children]);

    const handleTopScroll = () => {
        if (syncing.current) return;
        syncing.current = true;
        if (bottomScrollRef.current && topScrollRef.current) {
            bottomScrollRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        }
        syncing.current = false;
    };

    const handleBottomScroll = () => {
        if (syncing.current) return;
        syncing.current = true;
        if (topScrollRef.current && bottomScrollRef.current) {
            topScrollRef.current.scrollLeft = bottomScrollRef.current.scrollLeft;
        }
        syncing.current = false;
    };

    return (
        <div className={className}>
            <div
                ref={topScrollRef}
                onScroll={handleTopScroll}
                style={{ overflowX: 'auto', overflowY: 'hidden', height: '14px', marginBottom: '-1px' }}
            >
                <div className="scroll-spacer" style={{ height: '1px' }} />
            </div>
            <div
                ref={(el) => { bottomScrollRef.current = el; contentRef.current = el; }}
                onScroll={handleBottomScroll}
                style={{ overflowX: 'auto' }}
            >
                {children}
            </div>
        </div>
    );
}
